<script setup lang="ts">
const currentArticle = inject(keys.currentArticle)
</script>

<template>
  <section
    v-if="currentArticle"
    class="w-full bg-(--background) py-16 text-(--foreground) md:py-24"
    :class="currentArticle.colorTheme"
  >
    <UArticleContainer class="relative flex flex-col gap-8">
      <UiArticlesTheme prefix="Tema: " />
      <UiArticlesTitle class="text-4xl md:text-7xl" />
      <div class="pb-8 text-xl font-semibold md:text-3xl" v-html="currentArticle.intro" />
      <UiArticlesByline class="flex gap-4 font-headline text-xl md:absolute md:-bottom-8 md:left-[-7.3rem] md:items-center md:gap-8">
        <IconsGraphicsStarTag class="hidden md:flex" aria-hidden="true" />
      </UiArticlesByline>
    </UArticleContainer>
  </section>
</template>
